<template>
  <div class="page image-page">
    <div class="nav-bar-placeholder"></div>
    <div class="swiper-container">
      <div class="content">
        <h1>中国风格影像</h1>
        <p>
          针对中国丰富的物质与非物质文化遗产，数字影像的记录与制作成为了文化阐释与传播的重要手段，也积累了大量的优秀影像作品，例如《国宝档案》《中国古瓷》《中国青铜》《中国陶瓷》《中国博物馆之镇馆之宝》等记录片，还有以综艺节目形式呈现的《中国诗词大会》《了不起的匠人》《登场了！敦煌》《闪耀吧中华文明》等。海量的影像数据，不仅为设计师提供了中国风格历史、内涵、造型、纹样、颜色等各方面的创意设计信息，同时也为设计风格的产品宣传与平台推广提供了影像素材。
        </p>
      </div>
      <!--<swiper-navigation @change="swiperChange"/>-->
      <swiper
        :modules="modules"
        effect="fade"
        @swiper="onSwiper">
        <swiper-slide>
          <div class="banner-mask">
            <video src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481433530顶部视频（需叠加蒙版）.mp4" autoplay
                   muted loop></video>
          </div>
        </swiper-slide>
        <!--        <swiper-slide>-->
        <!--          <div class="banner-mask">-->
        <!--            <img src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672646034711-banner-picture2.jpg" alt="">-->
        <!--          </div>-->
        <!--        </swiper-slide>-->
      </swiper>
    </div>

    <div class="tab-block">
      <h2>知了青年</h2>
      <p>知了青年坚持创作人文纪实节目，以“文化+综艺”的模式发现美、设计美、传达美，让纪录片成为讲述中国故事的 “利器”</p>
      <el-tabs
        v-model="activeName1"
        style="--el-tabs-header-height:auto;--el-border-color-light:transparent;--el-text-color-primary:#ffffff;--el-color-primary:#FF0000">
        <el-tab-pane label="了不起的匠人" :name="0" lazy>
          <video
            src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481033995知了青年-了不起的匠人-滑动进入页面后自动播放.mp4"
            autoplay muted loop></video>
        </el-tab-pane>
        <el-tab-pane label="闪耀吧中华文明" :name="1" lazy>
          <video
            src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481032849知了青年-闪耀吧中华文明-切换tap后自动播放.mp4"
            autoplay muted loop></video>
        </el-tab-pane>
        <el-tab-pane label="登场了敦煌" :name="2" lazy>
          <video
            src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481027943知了青年-登场了敦煌-切换tap后自动播放.mp4"
            autoplay muted loop></video>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="tab-block">
      <h2>长沙铜官窑</h2>
      <p>长沙窑，即长沙铜官窑，兴起于唐朝，是中国乃至世界釉下彩瓷的开拓者</p>
      <el-tabs
        v-model="activeName3"
        style="--el-tabs-header-height:auto;--el-border-color-light:transparent;--el-text-color-primary:#ffffff;--el-color-primary:#FF0000">
        <el-tab-pane label="长沙窑影像设计" :name="0" lazy>
          <video
            src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677480941624长沙铜官窑-长沙窑影像设计-滑动进入页面后自动播放.mp4"
            autoplay muted loop></video>
        </el-tab-pane>
        <el-tab-pane label="如果瓷器会说话" :name="1" lazy>
          <video
            src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677480927779长沙铜官窑-如果瓷器会说话-切换tap后自动播放.mp4"
            autoplay muted loop></video>
        </el-tab-pane>
        <el-tab-pane label="长沙窑文化研究" :name="2" lazy>
          <video
            src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677480943481长沙铜官窑-长沙窑文化研究-切换tap后自动播放.mp4"
            autoplay muted loop></video>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="tab-block">
      <h2>新通道十周年</h2>
      <p>
        湖南大学“新通道”设计与社会创新项目，十余年来致力于探索如何通过创造性转化与创新性发展推动传统文化与当代文化的适应和融合</p>
      <el-tabs
        v-model="activeName2"
        style="--el-tabs-header-height:auto;--el-border-color-light:transparent;--el-text-color-primary:#ffffff;--el-color-primary:#FF0000">
        <el-tab-pane label="彩绘唐卡" :name="0" lazy>
          <video
            src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677480644512新通道十周年-彩绘唐卡-滑动进入自动播放.mp4"
            autoplay muted loop></video>
        </el-tab-pane>
        <el-tab-pane label="新华银器" :name="1" lazy>
          <video
            src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677480750363新通道十周年-新华银器-切换Tap后自动播放.mp4"
            autoplay muted loop></video>
        </el-tab-pane>
        <el-tab-pane label="藏经文化" :name="2" lazy>
          <video
            src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677480789108新通道十周年-藏经文化-切换Tap后自动播放.mp4"
            autoplay muted loop></video>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="tab-block">
      <h2>文物影像资源提取与处理</h2>
      <p>通过3D建模、数字扫描、影像处理等方式将各种类型的文物素材变成全方位展示的立体动态影像</p>
      <div class="img-grid">
        <div class="img-item" v-for="(item,index) in imageList" :key="index">
          <img :src="item.url" alt="">
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
// import SwiperNavigation from '@/components/SwiperNavigation/index'
// import CustomSwiper from '@/components/CustomSwiper/index'
import { Pagination, Autoplay, EffectFade } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import 'swiper/swiper.scss'
import 'swiper/modules/pagination/pagination.scss'

const modules = [Pagination, Autoplay, EffectFade]

const activeName1 = ref(0)
const activeName2 = ref(0)
const activeName3 = ref(0)

// 轮播图
let swiperRef = null

// function swiperChange (type) {
//   if (type === 'next') {
//     swiperRef.slideNext()
//   } else {
//     swiperRef.slidePrev()
//   }
// }

function onSwiper (swiper) {
  swiperRef = swiper
}

const imageList = [
  {
    url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481117055蛋青色提花生绫纱女单袄.gif',
    name: '蛋青色提花生绫纱女单袄'
  },
  {
    url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481111934白缎绣珍禽花卉纹对襟挂穗大坎.gif',
    name: '白缎绣珍禽花卉纹对襟挂穗大坎'
  },
  {
    url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481121683云南富宁彝族贴布蜡染女裙.gif',
    name: '云南富宁彝族贴布蜡染女裙'
  },
  {
    url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481116815黎族织锦筒裙.gif',
    name: '黎族织锦筒裙'
  },
  {
    url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481111604沉香木雕山水笔筒.gif',
    name: '沉香木雕山水笔筒'
  },
  {
    url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481110792乾隆金胎掐丝珐琅花瓶.gif',
    name: '乾隆金胎掐丝珐琅花瓶'
  },
  {
    url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481116610乾隆御用款金碗.gif',
    name: '乾隆御用款金碗'
  },
  {
    url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481117790清代肉型石.gif',
    name: '清代肉型石'
  },
  {
    url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481127439长沙窑青釉褐彩诗词壶.gif',
    name: '长沙窑青釉褐彩诗词壶'
  },
  {
    url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481138055阳陵虎符.gif',
    name: '阳陵虎符'
  },
  {
    url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481141578错银铜牛灯.gif',
    name: '错银铜牛灯'
  },
  {
    url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1677481134975鎏金铁心铜龙.gif',
    name: '鎏金铁心铜龙'
  }
]
</script>

<style scoped lang="scss">
.image-page {
  background-color: #000000;

  .nav-bar-placeholder {
    height: 90px;
  }
}

.tab-block {
  margin-bottom: 447px;

  h2 {
    font-weight: 600;
    font-size: 64px;
    color: #FFFFFF;
    text-align: center;
    font-family: 'NotoSerifSC', system-ui;
    margin-bottom: 25px;
  }

  p {
    font-family: 'NotoSerifSC', system-ui;
    font-size: 24px;
    line-height: 35px;
    text-align: center;
    color: #848484;
    margin-bottom: 100px;
  }

  video {
    width: 1418px;
    height: 798px;
    object-fit: cover;
  }
}

.el-tabs {
  width: 1418px;
  margin: 0 auto;

  :deep(.el-tabs__header) {
    margin-bottom: 30px;
  }

  :deep(.el-tabs__nav-scroll) {
    display: flex;
    justify-content: center;
    padding-bottom: 12px;
  }

  :deep(.el-tabs__item) {
    font-size: 36px;
    padding: 0 45px;
  }

  :deep(.el-tabs__active-bar.is-top) {
    background-color: transparent;
    bottom: -10px;

    &:after {
      content: '';
      display: block;
      width: 70px;
      height: 100%;
      margin: 0 auto;
      background-color: #FF0000;
    }

    //width: 70px !important;
  }
}

.swiper-container {
  position: relative;
  //height: 990px;
  margin-bottom: 300px;

  .swiper-slide {
    img, video {
      width: 100%;
      height: 700px;
      object-fit: cover;
    }
  }

  .content {
    color: white;
    width: 1100px;
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translateX(-50%);
    z-index: 3;

    h1 {
      font-size: 48px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 79px;
      font-family: 'NotoSerifSC', system-ui;
    }

    p {
      font-size: 18px;
      line-height: 45px;
      text-align: center;
    }
  }

  .navigation {
    position: absolute;
    z-index: 98;
    bottom: 44px;
    right: 90px;
  }

  .banner-mask:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    //background-color: rgba(0, 0, 0, .5);
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.8) 68.23%);
  }
}

.img-grid {
  margin: 0 auto;
  width: 1600px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .img-item {
    width: 350px;
    margin-bottom: 20px;

    img {
      width: 350px;
      margin: 0 auto;
      height: 352px;
      object-fit: contain;
    }

    p {
      font-family: 'NotoSerifSC', system-ui;
      font-weight: 400;
      font-size: 24px;
      text-align: center;
      text-transform: lowercase;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
</style>
